import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'
import { useMediaQuery } from 'src/lib/use-media-query'

export const TextHeaderDe = () => {
    const isMobile = useMediaQuery('(max-width: 767px)')

    return (
        <HighlightedText
            text="RUBBELN SIE DIE LOSE UND ERHALTEN SIE IHREN BONUS"
            highlights={[{ word: 'SIE IHREN BONUS' }]}
            breakAfterWords={isMobile ? ['LOSE', 'ERHALTEN'] : ['ERHALTEN']}
            className={styles.text_header}
        />
    )
}
